import { AllTableSorting } from '@prlw/core/monitor/types/all-table';
import {
  AllInstruments,
  Instrument,
} from '@prlw/core/monitor/all-instruments.entity';
import { allTableSortDefaults } from '@prlw/core/monitor/init/all-table';

const BASIS = 'Завод';

export function getAllTableSortDefault(columnName: string): AllTableSorting {
  const defaultSort = allTableSortDefaults.find(
    (sorting) => sorting.columnName === columnName,
  ) as AllTableSorting;
  return { ...defaultSort };
}

export function allTableCompareData(
  a: AllInstruments,
  b: AllInstruments,
  sorting: AllTableSorting,
): number {
  if (sorting.columnName !== BASIS) {
    const previous: Instrument | undefined =
      a.instrumentsByProductGroup[sorting.columnName];
    const current: Instrument | undefined =
      b.instrumentsByProductGroup[sorting.columnName];
    if (!previous && current) {
      return 1;
    }
    if (previous && !current) {
      return -1;
    }
    if (previous && current) {
      return previous.price > current.price === (sorting.direction === 'ASC')
        ? 1
        : -1;
    }
  }
  return a.shipmentBasis > b.shipmentBasis === (sorting.direction === 'ASC')
    ? 1
    : -1;
}
